import {IStore} from '$src/bootstrap/Store'
import {getMstStore} from '$src/bootstrap/rootSaga'

export default function* login(): Generator {
  const mstStore: IStore = yield getMstStore()
  mstStore.auth.setAsLoggedOut()
}



// WEBPACK FOOTER //
// ./src/auth/sagas/logout.ts